import { useStaticQuery, graphql } from "gatsby"

const useStaticData = () => {
  const cmsData = useStaticQuery(
    graphql`
      {
        allContentfulFooter {
          nodes {
            copyRight
            socialLinks {
              internalTitle
              iconClass
              link {
                label
                title
                url
                target
                imageType
                scrollToElementId
                gaEventClass
                gaEventLabel
                image {
                  title
                  description
                  url
                  width
                  height
                }
              }
            }
            mainLinks {
              title
              links {
                __typename
                ... on ContentfulLink {
                  label
                  title
                  url
                  target
                  scrollToElementId
                  gaEventClass
                  gaEventLabel
                  image {
                    title
                    description
                    url
                    width
                    height
                  }
                }
              }
            }
            secondaryLinks {
              title
              links {
                __typename
                ... on ContentfulLink {
                  label
                  title
                  url
                  target
                  scrollToElementId
                  gaEventClass
                  gaEventLabel
                  image {
                    title
                    description
                    url
                    width
                    height
                  }
                }
              }
            }
          }
        }
        allContentfulHeader {
          nodes {
            logoImg {
              altText
              imageDesktop {
                height
                description
                title
                width
                url
              }
              imageMobile {
                title
                width
                url
                description
                height
              }
            }
          }
        }
        contentfulJobFilter {
          filterData {
            selectFields {
              jobFamily {
                options {
                  label
                  value
                }
              }
            }
          }
          countriesList {
            countryName
            countryCode
            locations {
              label
              value
            }
            stateWithLocations {
              locations {
                label
                value
              }
              stateCode
              stateName
            }
          }
          languageList {
            label
            value
            flagIcon
          }
        }
        allContentfulJobDetailWrapper {
          nodes {
            breadCrumb {
              internalTitle
              heading
              breadcrumbTitle
              variant
              textUnderHeading
              shareThisEnabled
              link {
                name
                url
                label
                title
                target
                scrollToElementId
                imageType
                gaEventClass
                gaEventLabel
                ariaLabel
              }
              socialLinks {
                internalTitle
                link {
                  title
                  url
                  ariaLabel
                  images {
                    altText
                    imageMobile {
                      title
                      description
                      size
                      url
                      width
                      height
                    }
                    imageDesktop {
                      title
                      description
                      size
                      url
                      width
                      height
                    }
                  }
                }
              }
              isBreadcrumb
            }
            jobDetailBanner {
              images {
                altText
                imageDesktop {
                  file {
                    url
                    fileName
                  }
                }
              }
            }
            jobDetailCardsLayout {
              isSlider
              isDesktopSlider
              variant
              isContentReversed
              cards {
                variant
                link {
                  name
                  url
                  label
                  title
                  target
                  scrollToElementId
                  imageType
                  gaEventClass
                  gaEventLabel
                  ariaLabel
                }
                images {
                  altText
                  imageDesktop {
                    file {
                      url
                      fileName
                    }
                  }
                  imageMobile {
                    file {
                      url
                      fileName
                    }
                  }
                }
              }
            }
            textContent {
              title
              shortDescription {
                shortDescription
              }
            }
          }
        }
      }
    `
  )

  return cmsData
}

export default useStaticData
